export class FolderAttributeModificationNotification {
	public folderId: string;
	public viewId: number;
	public attributeId: number;
	public attributeOldValue: string;
	public attributeNewValue: string;

	public static fromJson(other: any): FolderAttributeModificationNotification {
		const instance = new FolderAttributeModificationNotification();
		instance.viewId = other.ViewId;
		instance.folderId = other.FolderId;
		instance.attributeId = other.AttributeId;
		instance.attributeOldValue = other.AttributeOldValue;
		instance.attributeNewValue = other.AttributeNewValue;
		return instance;
	}
}
